import React from "react";

const FooterApp = () => {
  return (
    <footer>
      <p className="text-center bg-white text-sm text-gray-500 p-5">
        © 2022-{new Date().getFullYear()}{" "}{" "}
        <a
          href="https://jatinderkaur.in"
          className="hover:underline"
          target="_blank"
        >
          Developed by Jatinder Kaur
        </a>
        . All rights reserved.
      </p>
    </footer>
  );
};

export default FooterApp;
